@if (isOpen()) {
  <div class="modal-backdrop" (click)="closeModal()"></div>
}

@if (isOpen()) {
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h2 class="text-xl font-semibold text-gray-800">
          {{ isAddInsightsModal() ? 'Add Insights to Canvas' : 'Add Content to Canvas' }}
        </h2>
        <button (click)="closeModal()" class="p-1 rounded-full hover:bg-gray-100">
          <ui-icon name="x" class="stroke-gray-500 size-5"></ui-icon>
        </button>
      </div>

      <!-- Tabs -->
      <div class="tabs-container">
        <button
          [class.active-tab]="activeTab() === 'reports'"
          (click)="switchTab('reports')"
          class="tab-button">
          <ui-icon name="reports" class="mr-2" size="size-5"></ui-icon>
          Reports
        </button>
        <button
          [class.active-tab]="activeTab() === 'conversations'"
          (click)="switchTab('conversations')"
          class="tab-button">
          <ui-icon name="data-copilot" class="mr-2" size="size-5"></ui-icon>
          Conversations
        </button>
        @if (!isAddInsightsModal()) {
          <button
            [class.active-tab]="activeTab() === 'custom'"
            (click)="switchTab('custom')"
            class="tab-button">
            Custom
          </button>
        }
      </div>

      <!-- Tab Content -->
      <div class="tab-content">
        <!-- Reports Tab -->
        <div [hidden]="activeTab() !== 'reports'">
          @if (!loadingReports()) {
            <app-assets-flat-list-table
              [listType]="listType()"
              [assetType]="'REPORT'"
              [assetsInput]="reports()"
              [hideDateFilter]="true"
              [assetHeight]="280"
              [showSelectionCheckbox]="true"
              [disabledAssetIds]="disabledReportIdsArray()"
              [hideActionButtons]="true"
              (changeListType)="changeListType($event)"
              (selectedItemsChange)="handleSelectionChange($event)">
            </app-assets-flat-list-table>
          }

          @if (loadingReports()) {
            <ui-skeleton-table></ui-skeleton-table>
          }
        </div>

        <!-- Conversations Tab -->
        @if (activeTab() === 'conversations') {
          <div class="conversations-tab">
            <!-- Search Input -->
            <div class="mb-4 px-1">
              <div class="relative">
                <div class="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
                  <ui-icon name="search" class="stroke-gray-400" size="size-4"></ui-icon>
                </div>
                <input
                  type="text"
                  [formControl]="searchControl"
                  class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
                  placeholder="Search conversation">
              </div>
            </div>

            @if (loadingConversations()) {
              <div class="flex justify-center items-center py-8">
                <div class="animate-pulse flex flex-col w-full space-y-4">
                  <div class="h-8 bg-gray-200 rounded w-3/4"></div>
                  <div class="h-8 bg-gray-200 rounded w-5/6"></div>
                  <div class="h-8 bg-gray-200 rounded w-4/5"></div>
                </div>
              </div>
            }

            @if (!loadingConversations() && conversationsSignal().length === 0) {
              <div class="flex items-center justify-center h-64">
                <div class="text-center">
                  <ui-icon name="data-copilot" class="mx-auto mb-4" size="size-12"></ui-icon>
                  <p class="text-gray-500 mb-2">No conversations found</p>
                  <p class="text-gray-400 text-sm">Conversations will appear here once created</p>
                </div>
              </div>
            }

            @if (!loadingConversations() && conversationsSignal().length > 0) {
              <div class="conversation-list">
                @for (conversation of filteredConversationsList(); track conversation.id) {
                  <div class="conversation-item">
                    <!-- Conversation Header -->
                    <div class="conversation-header" (click)="toggleConversation(conversation.id, $event)">
                      <div class="expand-button">
                        @if (isConversationExpanded(conversation.id)) {
                          <ui-icon
                            name="chevron-down"
                            class="stroke-[#999999] stroke-[2.5px] cursor-pointer hover:stroke-blue-700"
                            size="size-4">
                          </ui-icon>
                        } @else {
                          <ui-icon
                            name="chevron-right"
                            class="stroke-[#999999] stroke-[2.5px] cursor-pointer hover:stroke-blue-700"
                            size="size-4">
                          </ui-icon>
                        }
                      </div>
                      <div class="conversation-title">
                        @if (conversation.parameters?.pinned) {
                          <span class="pinned-icon" title="Pinned conversation">
                            <ui-icon name="pin" size="size-3" class="text-blue-500 mr-1"></ui-icon>
                          </span>
                        }
                        {{ conversation.name || 'Untitled Conversation' }}
                      </div>
                    </div>

                    <!-- Expanded conversation content with questions -->
                    @if (isConversationExpanded(conversation.id)) {
                      <div class="conversation-content">
                        @if (!isQuestionLoading(conversation.id) && hasQuestions(conversation.id)) {
                          <div class="questions-list">
                            @for (question of getFilteredQuestions(conversation.id); track question.id) {
                              <div
                                class="question-item"
                                [class.selected]="isQuestionSelected(question.id) || isQuestionAddedToCanvas(question.id)"
                                [class.disabled]="isQuestionAddedToCanvas(question.id)"
                                (click)="!isQuestionAddedToCanvas(question.id) && toggleQuestionSelection(question, $event)">
                                <div class="question-content">
                                  <div class="checkbox-wrapper">
                                    <input
                                      type="checkbox"
                                      [checked]="isQuestionSelected(question.id) || isQuestionAddedToCanvas(question.id)"
                                      [disabled]="isQuestionAddedToCanvas(question.id)"
                                      (click)="$event.stopPropagation()"
                                      (change)="!isQuestionAddedToCanvas(question.id) && toggleQuestionSelection(question, $event)"
                                      class="form-checkbox"
                                      aria-label="Select question"
                                    />
                                  </div>
                                  <span class="question-text">{{ question.text }}</span>
                                </div>
                              </div>
                            }
                          </div>
                        }

                        @if (!isQuestionLoading(conversation.id) && !hasQuestions(conversation.id)) {
                          <div class="no-questions">
                            <ui-icon name="message-question" class="mx-auto mb-2 no-questions-icon" size="size-5"></ui-icon>
                            <p class="text-gray-500 text-sm">No questions found in this conversation</p>
                          </div>
                        }

                        @if (isQuestionLoading(conversation.id)) {
                          <div class="questions-loading">
                            <div class="animate-pulse flex flex-col space-y-3">
                              <div class="flex items-center space-x-3">
                                <div class="h-4 w-4 bg-gray-200 rounded"></div>
                                <div class="h-4 bg-gray-200 rounded w-3/4"></div>
                              </div>
                              <div class="flex items-center space-x-3">
                                <div class="h-4 w-4 bg-gray-200 rounded"></div>
                                <div class="h-4 bg-gray-200 rounded w-5/6"></div>
                              </div>
                              <div class="flex items-center space-x-3">
                                <div class="h-4 w-4 bg-gray-200 rounded"></div>
                                <div class="h-4 bg-gray-200 rounded w-4/5"></div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                @if (filteredConversationsList().length === 0) {
                  <div class="flex items-center justify-center h-48">
                    <div class="text-center">
                      <div class="flex justify-center w-full">
                        <ui-icon name="search" class="mb-4 stroke-gray-400" size="size-8"></ui-icon>
                      </div>
                      <p class="text-gray-500 mb-1 font-bold">No results found</p>
                      <p class="text-gray-400 text-sm">Try adjusting your search terms</p>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        <!-- Custom Tab -->
        @if (activeTab() === 'custom' && !isAddInsightsModal()) {
          <div class="custom-tab">
            <div class="custom-cards-container">
              <!-- Free Form Text Card -->
              <div class="custom-card custom-card-with-tooltip"
                   [class.clickable]="isCanvasSaved"
                   [class.disabled]="!isCanvasSaved"
                   (click)="onCustomCardClick('freeform-card')">
                <div class="custom-card-icon">
                  <ui-icon name="pencil"
                           [class.stroke-blue-600]="isCanvasSaved"
                           [class.stroke-gray-400]="!isCanvasSaved"
                           size="size-8"></ui-icon>
                </div>
                <div class="custom-card-content">
                  <h3 class="custom-card-title">Free Form Card</h3>
                  <p class="custom-card-description">Add rich text content with formatting options</p>
                </div>
                @if (!isCanvasSaved) {
                  <div class="custom-card-tooltip">
                    Save canvas first to enable this option
                  </div>
                }
              </div>

              <!-- Coming Soon Card -->
              <div class="custom-card disabled">
                <div class="custom-card-icon">
                  <ui-icon name="clock" class="stroke-gray-400" size="size-8"></ui-icon>
                </div>
                <div class="custom-card-content">
                  <h3 class="custom-card-title">Coming Soon</h3>
                  <p class="custom-card-description">More custom content types coming soon</p>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <div class="flex-1">
          @if (totalSelectedCount > MAX_ITEMS_LIMIT) {
            <span class="text-red-600 text-sm">
              Maximum of 5 items can be selected
            </span>
          }
        </div>
        <button
          (click)="closeModal()"
          class="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
          Cancel
        </button>
        <button
          (click)="addSelectedToCanvas()"
          class="px-4 py-2 text-white rounded-md ml-2"
          [ngClass]="{
            'bg-blue-600 hover:bg-blue-700': !isAddButtonDisabled,
            'bg-gray-400 cursor-not-allowed': isAddButtonDisabled
          }"
          [disabled]="isAddButtonDisabled">
          {{ isAddInsightsModal() ? 'Add Insights to Canvas' : 'Add to Canvas' }}
        </button>
      </div>
    </div>
  </div>
}
